import React, { useContext, useState } from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { makeStyles } from '@mui/styles';
import { appCtx } from 'components/appStore';

import Typography from '@mui/material/Typography';
import GradeCardNavigation from './components/GradeCardNavigation';
import TasksGradeBlock from './components/TasksGradeBlock';
import SimpleGradeBlock from './components/SimpleGradeBlock';
import ScreenList from './components/ScreenList';

const useStyles = makeStyles(theme => ({
    wrapper: {
        position: 'relative',
        paddingLeft: 86,
        zIndex: 100,
        borderRadius: 4,
        borderTop: `2px solid ${theme.palette.grey[200]}`,
        borderBottom: `2px solid ${theme.palette.grey[200]}`,
        borderRight: `2px solid ${theme.palette.grey[200]}`,
        minHeight: ({ totalCount }) => totalCount * 70 + 60
    },
    wrapperExtented: {
        paddingLeft: 170
    }
}));

const GradeBlock = observer(({
    candidate, gradeableCard, propPublic, isIntegration, audition, gradeProps, hideCandidateDetails, userAudition
}) => {
    const [gradeLoading, setGradeLoading] = useState(false);

    const { screenQuestionResults, currentQuestion, questionResults, gotoQuestion,
        currentGrade, questionNumber, setGradeQuestion, screenSelected, setScreenSelected, taskNumber, setTaskNumber
    } = gradeProps;

    const { company } = useContext(appCtx);

    const classes = useStyles({
        totalCount: Math.max((questionResults.length + (screenQuestionResults.length ? 1 : 0)),
		currentQuestion?.candidateTasks?.length || 0)
    });

    const { userAuditionId, fullName } = candidate;
    const showTasks = Boolean(currentQuestion?.candidateTasks?.length);

    if (!questionResults.length && !screenQuestionResults.length) return null;

    const commonProps = {
        candidate,
        audition: null,
        updateUserAuditionAndBox: null,
        gradeableCard,
        propPublic,
        gotoQuestion,
        isIntegration,
        gradeLoading,
        canGrade: false,
        currentGrade,
        currentQuestion,
        fullName,
        questionResults,
        questionNumber,
        setGradeQuestion,
        setGradeLoading
    };

    return (
        <div>
            <Typography className="u-mrg--bx2 u-mrg--tx4" variant="h5">Candidate Answers</Typography>
            <div className={clsx(classes.wrapper, showTasks && classes.wrapperExtented)}>
                <GradeCardNavigation
                    questions={questionResults}
                    questionNumber={questionNumber}
                    gotoQuestion={gotoQuestion}
                    propPublic={propPublic}
                    screenSelected={screenSelected}
                    setScreenSelected={setScreenSelected}
                    hasScreenQuestions={Boolean(screenQuestionResults.length)}
                    company={company}
                />
                {
                    screenSelected ? (
                        <ScreenList
                            screenQuestionResults={screenQuestionResults}
                            userAuditionId={propPublic ? userAudition?.uuid : userAuditionId}
                            screeningChatbotEnabled={audition?.screeningChatbotEnabled}
                            hideCandidateDetails={hideCandidateDetails}
                            isPublic={propPublic}
                        />
                    ) : (
                        <>
                            {
                                showTasks ? (
                                    <TasksGradeBlock
                                        taskNumber={taskNumber}
                                        setTaskNumber={setTaskNumber}
                                        {...commonProps}
                                    />
                                ) : (
                                    <SimpleGradeBlock {...commonProps} />
                                )
                            }
                        </>
                    )
                }
            </div>
        </div>
    );
});

export default GradeBlock;
